import { checkStatus } from '../authFunctions';
import ERROR_CODES from '../ErrorCodes';

const identityV4Url = `${window.__ENV__.BFF_URL}/identity/v4/member/authorize`;

/**
 * Authorize a member and return a full member JWT
 * @param {Object} partialJWT - JWT to be passed for gb-authorization header
 * @param {string} clientNumber - requested clientNumber to authorize with
 * @param {string} certificate - requested certificate to authorize with
 * @param {string} transactionId - transactionId to be passed for mli-session-correlation-id header
 */
export const getFullJwt = async (partialJWT, clientNumber, certificate, transactionId) => {
  const method = 'POST';
  const headers = {
    'Content-Type': 'application/json',
    'mli-session-correlation-id': transactionId,
    'mli-channel': 'web',
    'gb-authorization': partialJWT,
  };
  const body = {
    clientNumber,
    certificate,
  };

  try {
    const response = await fetch(identityV4Url, {
      method,
      headers,
      body: JSON.stringify(body),
    }).then(checkStatus);

    const fullJwtResponseBody = await response.json();

    // Calculating clock correction for session expiration management
    const serverTimestamp = fullJwtResponseBody['gb-server-timestamp'];
    sessionStorage.setItem('MPROFILE_SESSION_OFFSET', serverTimestamp - Date.now());

    return fullJwtResponseBody;
  } catch (error) {
    throw new Error(ERROR_CODES.GET_FULL_JWT_FAILED);
  }
};
